<template>
  <dialog-modal-fi
    ref="productRetailerDialog"
    class="product-retailer-dialog-fi"
    large-padding
    lazy
  >
    <template #header>
      <h2 class="product-retailer-dialog-fi__headline">
        {{
          fields &&
          fields.retailConnectRetailerHeadline &&
          fields.retailConnectRetailerHeadline.value
        }}
      </h2>
    </template>

    <template #body>
      <div class="product-retailer-dialog-fi__product-retailers">
        <online-retailers-list-fi
          :retailers="retailers"
          :retailer-facets="retailerFacets"
          variant="product-retailers"
        />
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script>
import { DialogModalFi } from 'atoms';

import OnlineRetailersListFi from '@/components/online-retailers/OnlineRetailersListFi.vue';

export default {
  name: 'ProductRetailerDialogFi',
  components: {
    DialogModalFi,
    OnlineRetailersListFi,
  },
  inject: ['fields'],
  props: {
    retailers: {
      type: Array,
      default: null,
    },
    retailerFacets: {
      type: Array,
      default: null,
    },
  },
  methods: {
    show() {
      this.$refs.productRetailerDialog.open();
    },
    close() {
      this.$refs.productRetailerDialog.close();
    },
  },
};
</script>

<style src="./product-retailer-dialog-unscoped-fi" />
